/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Missing_ColumnInputs */

const en_issue_missing_column = /** @type {(inputs: Issue_Missing_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`column missing`)
};

/**
* | output |
* | --- |
* | "column missing" |
*
* @param {Issue_Missing_ColumnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_missing_column = /** @type {((inputs?: Issue_Missing_ColumnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Missing_ColumnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_missing_column(inputs)
});